export interface IPosition {
  x: number;
  y: number;
  z: number;
}

export type IPosition2d = Omit<IPosition, 'z'>;


export enum DataDirection {
  Forward = "F",
  Backward = "B"
}